import React, { useState } from "react";
import { Form, Input, Select, notification, Checkbox } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { validatePassword, parseJwt } from "../../../../utilities/helpers";
import { languageLable } from "utilities/helpers";
import API from "api/api";

const { Option } = Select;

const api = new API();

export default function RegisterFormField({ doctorHospitals, customerTypes }) {
    const [isDisabled, setIsDisabled] = useState(false);
  const [form] = Form.useForm();
  const history = useHistory();
  const appState = useSelector((state) => state);
  const { selectedLanguageData } = appState?.app;
  const { countries } = appState?.auth;
  const dispatch = useDispatch();
   
  const handleSubmit = async (values) => {
    try {
      const payload = {
        name: `${values.firstName} ${values.lastName}`,
        email: values.email,
        isdCode: values.isdCode,
        mobile: values.mobile,
        password: values.password,
        confirmPassword: values.cpassword,
        customerTypeId: values.customerTypeId ?? null,
        sendWhatsappOTP: values.whatsapp,
        isExisting: isDisabled
      };
      const response = await api.post("RegisterWithCustomFields", {
        data: payload,
      });

      if (response.StatusCode === 200) {
          // Do direct login as Token is available
          // Remove register details
          localStorage.removeItem("registerRequestData");

          // SET DATA TO REDUX
          dispatch({
              type: "REGISTER_REQEUST",
              registerRequestData: payload,
          });

          localStorage.setItem("registerRequestData", JSON.stringify(payload));
          if (response.Result.LoginToken) {
              const loginToken = response.Result.LoginToken;
              // Dummy token - "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiSmVldmFuIEp5b3QgQ2hhcml0YWJsZSBUcnVzdCIsInVzZXJuYW1lIjoicmF2YWxkcmRlZXBhQGdtYWlsIiwiaWQiOiIzY2Y1NjBjYi0zMGRiLTRlMTItYjg0YS00NDA5Mjg5MjdkYzIiLCJjb3VudHJ5Y29kZSI6Iis5MSIsInBob25lbnVtYmVyIjoiKzkxLTU5OTk5OTk5OTkiLCJtb2JpbGUiOiI5NzI0MzEyMTY4IiwiZW1haWwiOiJyYXZhbGRyZGVlcGFAZ21haWwuaW4iLCJDb2RlIjoiMDAwMTIwNTAwMCIsInJlZmVycmFsY29kZSI6IjhZNU9WRSIsImN1c3RvbWVyIjoidHJ1ZSIsImNhbl9vcmRlciI6InRydWUiLCJjYW5fcGF5bGF0ZXIiOiJ0cnVlIiwiY2FuX2FjY2Vzc19hYm91dF91cyI6InRydWUiLCJjYW5fYWNjZXNzX2Jpb3RlY2hfa25vd2xlZGdlX2FjYWRlbXkiOiJ0cnVlIiwiY2FuX2FjY2Vzc19ncm91cF9wcm9maWxlXzEiOiJ0cnVlIiwiY2FuX2FjY2Vzc19ncm91cF9wcm9maWxlXzIiOiJ0cnVlIiwiY2FuX2FjY2Vzc19ncm91cF9wcm9maWxlXzMiOiJ0cnVlIiwiY2FuX2FjY2Vzc19uZXdzIjoidHJ1ZSIsImNhbl9hY2Nlc3NfcGF0aWVudF9lZHVjYXRpb24iOiJ0cnVlIiwiY2FuX2FjY2Vzc19wcm9kdWN0X2Jyb2NodXJlcyI6InRydWUiLCJjYW5fYWNjZXNzX3Byb2R1Y3RfYnJvY2h1cmVzX2V4dGVuZGVkIjoidHJ1ZSIsImNhbl9hY2Nlc3NfcHJvZHVjdF9pbnF1aXJpZXMiOiJ0cnVlIiwiY2FuX2FjY2Vzc19wcm9kdWN0X3Jldmlld3MiOiJ0cnVlIiwiY2FuX2FjY2Vzc19wcm9kdWN0cyI6InRydWUiLCJjYW5fYWNjZXNzX3Byb2R1Y3RfdmlzdWFsaXphdGlvbnMiOiJ0cnVlIiwiY2FuX2FjY2Vzc19wdWJsaWNhdGlvbnMiOiJ0cnVlIiwiY2FuX2FjY2Vzc19yZWNvbW1lbmRlZF9jb250ZW50IjoidHJ1ZSIsImNhbl9hY2Nlc3Nfc3VjY2Vzc19zdG9yaWVzIjoidHJ1ZSIsImNhbl9hY2Nlc3NfdmlzaW9uX3NpbXVsYXRvciI6InRydWUiLCJjYW5fYWNjZXNzX3doYXRfZG9jdG9yX3NheXMiOiJ0cnVlIiwibmJmIjoxNzQxMjY1MTE5LCJleHAiOjE3NTY4MTcxMTksImlhdCI6MTc0MTI2NTExOSwiaXNzIjoiY29tLmFyY2hpc3lzLmFydGlzIiwiYXVkIjoiY29tLmFyY2hpc3lzLmJpb3RlY2gifQ.qz4bEkSZ0Lx_SNjDzW5Y9HD63HgpQGka9CjIqxWCL74";

              // Remove register details
              localStorage.removeItem("registerRequestData");

              localStorage.setItem("authToken", loginToken);
              const tokenData = parseJwt(loginToken);
              localStorage.setItem("userData", JSON.stringify(tokenData));
              localStorage.setItem("isLoggedIn", true);
              localStorage.setItem("isVerified", false);

              // SET DATA TO REDUX
              dispatch({
                  type: "LOGIN_USER",
                  authToken: loginToken,
                  userData: tokenData,
              });

              dispatch({
                  type: "EMAIL_PHONE_CONFIRMATION_MODAL",
                  emailPhoneConfirmationModal: true,
              });

            history.push("/account/register-verify-btn");
          //history.push("/");
        } else {
          // SET DATA TO REDUX
          notification.success({
            message: "Success",
            description: languageLable(selectedLanguageData, response.Message),
          });
          history.push("/account/verify-otp");
        }
      } else {
        notification.info({
          message: "info",
          description: languageLable(selectedLanguageData, response.Message),
        });
      }
    } catch (e) {
      console.log("Due Invoice ~ fetchInvoice ~ e:", e);
    }
  };

    const handleDoctorHospitalChange = (id) => {
      const doctor = doctorHospitals.find((item) => item.Id === id);
      if (doctor && doctor.IsIntegrated && doctor.IsVerified) {
          notification.warning({
              message: "",
              description: languageLable(
                  selectedLanguageData,
                  "Already Register! Please login with email: "
              ) + doctor.Email,
          });
          return;
      }
        if (doctor) {
            setIsDisabled(true);
          const name = doctor.Name.split(" ");
          form.setFieldsValue({
            mobile: doctor.Mobile,
            email: doctor.Email,
            isdCode: doctor.IsdCode,
            firstName: name[0] ?? "",
            lastName: name[1] ?? "",
          });
        }
  };

  const isdCodeSelector = (
      <Form.Item name="isdCode" noStyle>
          {isDisabled ? <Input
              readOnly
              value={form.getFieldValue("countryCode")} // or any field you're using
              style={{ width: 120 }}
          /> :
              <Select
                  style={{
                      width: 120,
                  }}
                  showSearch
                  optionFilterProp="children"
              >
                  {countries &&
                      countries.map((item) => (
                          <Option value={item.phone_code}>
                              {item.phone_code} - {item.name}
                          </Option>
                      ))}
              </Select>}
        
    </Form.Item>
  );

  return (
    <>
      {/* <div className="form-group">
        <Form.Item className="">
          <Select
            placeholder="Doctor / Hospital Name"
            showSearch
            optionFilterProp="children"
            onChange={handleDoctorHospitalChange}
          >
            {(doctorHospitals || []).map((item) => (
              <Option key={item.Id} value={item.Id}>
                {item.Name} - {item.Address?.City}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div> */}

      <Form
        onFinish={handleSubmit}
        className="ps-form--account ps-form--account-register"
              form={form}
              initialValues={{
                  isdCode: countries.find(c => c.name === localStorage.getItem("setSelectedCountry") ?? "India")?.phone_code || "91"
  }}
      >
        <div className="ps-form__content">
          <div className="form-group">
            <Form.Item
              name="firstName"
              rules={[
                {
                  required: true,
                  message: languageLable(
                    selectedLanguageData,
                    "Please enter first name."
                  ),
                },
              ]}
            >
              <input
                id="firstName"
                className="form-control"
                name="firstName"
                type="text"
                placeholder={languageLable(selectedLanguageData, "First name*")}
              ></input>
            </Form.Item>
          </div>
          <div className="form-group">
            <Form.Item
              name="lastName"
              rules={[
                {
                  required: true,
                  message: languageLable(
                    selectedLanguageData,
                    "Please enter last name."
                  ),
                },
              ]}
            >
              <input
                id="lastName"
                className="form-control"
                name="lastName"
                type="text"
                placeholder={languageLable(selectedLanguageData, "Last name*")}
              ></input>
            </Form.Item>
          </div>
          <div className="form-group">
            <Form.Item
              name="mobile"
              
                          rules={[
                              {
                                  required: true,
                                  message: languageLable(
                                      selectedLanguageData,
                                      "Please enter mobile number."
                                  ),
                              },
                              ({ getFieldValue }) => ({
                                  validator(_, value) {
                                      const isdCode = getFieldValue("isdCode"); // selected ISD code
                                      console.log("isdCode: ", isdCode);
                                      if (!value) return Promise.resolve();
                                      const tenDigitCountries = ["90", "57", "212", "91"];
                                      const elevenDigitCountries = ["55"];
                                      const nineDigitCountries = ["34"];

                                      // Apply 10-digit validation for listed countries
                                      if (tenDigitCountries.includes(isdCode)) {
                                          if (!/^\d{10}$/.test(value)) {
                                              return Promise.reject(
                                                  new Error(`Mobile number must be 10 digits for +${isdCode}`)
                                              );
                                          }
                                      }

                                      // Apply 11-digit validation for listed countries
                                      if (elevenDigitCountries.includes(isdCode)) {
                                          if (!/^\d{11}$/.test(value)) {
                                              return Promise.reject(
                                                  new Error(`Mobile number must be 11 digits for +${isdCode}`)
                                              );
                                          }
                                      }

                                      // Apply 9-digit validation for listed countries
                                      if (nineDigitCountries.includes(isdCode)) {
                                          if (!/^\d{9}$/.test(value)) {
                                              return Promise.reject(
                                                  new Error(`Mobile number must be 9 digits for +${isdCode}`)
                                              );
                                          }
                                      }
                                      return Promise.resolve();
                                  },
                              }),
                          ]}
                >
                    {isDisabled ? <Input
                        readOnly
                        addonBefore={isdCodeSelector}
                        id="mobile"
                        name="mobile"
                        placeholder={languageLable(
                            selectedLanguageData,
                            "Mobile Number*"
                        )}
                        type="text"
                    /> : <Input
                        addonBefore={isdCodeSelector}
                        id="mobile"
                        name="mobile"
                        placeholder={languageLable(
                            selectedLanguageData,
                            "Mobile Number*"
                        )}
                        type="text"
                    /> }
              
            </Form.Item>
          </div>
          <div className="form-group">
            <Form.Item
              name="email"
              rules={[
                {
                  type: "email",
                  required: true,
                  message: languageLable(
                    selectedLanguageData,
                    "Please enter email"
                  ),
                },
              ]}
            >
            {isDisabled ? <input
                readOnly
                id="email"
                className="form-control"
                name="email"
                              type="email"
                              style={{
                                  width: "100%",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                              }}
                placeholder={languageLable(selectedLanguageData, "Email Id*")}
            ></input> : <input
                id="email"
                className="form-control"
                name="email"
                type="email"
                placeholder={languageLable(selectedLanguageData, "Email Id*")}
            ></input> }
              
            </Form.Item>
          </div>
          <div className="form-group">
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: languageLable(
                    selectedLanguageData,
                    "Please enter password."
                  ),
                },
              ]}
            >
              <Input.Password
                id="password"
                className="form-control"
                name="password"
                type="password"
                placeholder={languageLable(selectedLanguageData, "Password*")}
              />
            </Form.Item>
            <span className="password-helper">
              {languageLable(
                selectedLanguageData,
                "Your password length should be 6 to 20 characters & must contain 1-Uppercase, Lowercase, Numeric and Special Character"
              )}
            </span>
          </div>
          <div className="form-group">
            <Form.Item
              name="cpassword"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: languageLable(
                    selectedLanguageData,
                    "Please enter confirm password."
                  ),
                },

                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    let passwordErros = validatePassword(value);
                    if (passwordErros.length > 0) {
                      return Promise.reject(passwordErros.join("\n"));
                    }

                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      languageLable(
                        selectedLanguageData,
                        "The passwords and confirm password does not match."
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                id="cpassword"
                className="form-control"
                name="cpassword"
                type="password"
                placeholder={languageLable(
                  selectedLanguageData,
                  "Confirm Password*"
                )}
              />
            </Form.Item>
        </div>
        <div className="form-group">
            <Form.Item
                id="terms"
                name="terms"
                valuePropName="checked"
                initialValue={true}
                rules={[
                    {
                        validator: (_, value) =>
                            value
                                ? Promise.resolve()
                                : Promise.reject(
                                    new Error(
                                        languageLable(
                                            selectedLanguageData,
                                            "You must accept the terms and conditions"
                                        )
                                    )
                                ),
                    },
                ]}
            >
            <Checkbox>
                {languageLable(
                    selectedLanguageData,
                    "I agree to") + " "}
                <a
                    href="/static/media/Terms%20and%20Conditions.e97e6f244389bf48d308.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#1890ff", textDecoration: "underline" }}
                >
                    {languageLable(selectedLanguageData, "Terms and Conditions")}
                </a>
            </Checkbox>
            </Form.Item>
                  </div>

                  <div className="form-group">
                      <Form.Item
                          id="whatsapp"
                          name="whatsapp"
                          valuePropName="checked"
                      >
                          <Checkbox>
                              {languageLable(
                                  selectedLanguageData,
                                  "I agree to receive the OTP on WhatsApp for verification purposes."
                              )}
                          </Checkbox>
                      </Form.Item>
                  </div>

          <div className="form-group">
            <Form.Item name="customerTypeId" initialValue={customerTypes?.[0]?.Id}>
              <Select
                name="customerTypeId"
                placeholder="Customer Type"
                showSearch
                optionFilterProp="children"
                
                // onChange={(id) => setCustomerType(id)}
              >
                {(customerTypes || []).map((item) => (
                  <Option key={item.Id} value={item.Id}>
                    {item.Name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div className="form-group submit">
            <button type="submit" className="ps-btn ps-btn--fullwidth">
              {languageLable(selectedLanguageData, "Register")}
            </button>
          </div>
        </div>
              
      </Form>
    </>
  );
}
